import XAPPService from "app/Core/services/XAPPService";
import _ from "lodash";
export const GET_DATA = "[SUGGESTION FIELD] GET DATA";
export const SUGGESTION_ERROR = "[SUGGESTION FIELD] SUGGESTION ERROR";


export function list(_AParams, _ATarget, _ACampo, _ATexto, _ACallback = null) {
    return (dispatch) => {
        var AConditionsAND = [
            { "Campo": _ACampo, "Operador": "LIKE", "Valor": _ATexto + "%" },
            { "Campo": "pessoaformulario.statusregistro", "Operador": "=", "Valor": "1" }
        ];
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, _ATarget, AActions, _ATarget, ["*"], "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_DATA,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ]).then(() => {
                    if (!_.isNull(_ACallback)) {
                        _ACallback();
                    }
                })
            )
            .catch(error => {
                return dispatch({
                    type: SUGGESTION_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_DATA,
        payload: null
    };
}